<template>
  <div class="grid grid-cols-5 gap-3 p-3">
    <button
      v-for="a in avatars"
      :key="a.emoji"
      class="w-12 h-12 rounded-full flex items-center justify-center text-2xl transition-all hover:scale-110"
      :class="a.emoji === selected
        ? 'bg-blue-100 ring-2 ring-blue-500 shadow-md'
        : 'bg-[var(--mt-badge-muted-bg)] hover:bg-[var(--mt-hover)]'"
      :title="a.label"
      @click="$emit('select', a.emoji)"
    >
      {{ a.emoji }}
    </button>
  </div>
</template>

<script setup>
defineProps({
  selected: { type: String, default: null },
});

defineEmits(['select']);

const avatars = [
  { emoji: '🦁', label: 'Lion' },
  { emoji: '🐼', label: 'Panda' },
  { emoji: '🦊', label: 'Fox' },
  { emoji: '🐱', label: 'Cat' },
  { emoji: '🐶', label: 'Dog' },
  { emoji: '🦄', label: 'Unicorn' },
  { emoji: '🐸', label: 'Frog' },
  { emoji: '🐵', label: 'Monkey' },
  { emoji: '🦋', label: 'Butterfly' },
  { emoji: '🐲', label: 'Dragon' },
];
</script>
